import { Checkbox, TableCell, TableRow } from "@mui/material";
import moment from "moment";
import React from "react";

const toTitleCase = (value) => {
  if (typeof value !== "string") return "";
  if (!value) return "";
  return value.charAt(0).toUpperCase() + value.slice(1);
};

const GAUsersTableRow = ({
  isItemSelected,
  row,
  numberType,
  handleClickRow,
  labelId,
  handleNavigateToDetails,
  columnWidths,
}) => {
  return (
    <TableRow
      hover
      // onClick={(event) => handleClickRow(event, row.id)}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.id}
      selected={isItemSelected}
      sx={{
        cursor: "pointer",
        height: 30,
        background: numberType === true ? "#F2F2F2" : "#fff",
      }}
    >
      <TableCell
        padding="checkbox"
        style={{ background: "#fff" }}
        onClick={(event) => handleClickRow(event, row.id)}
      >
        <Checkbox
          color="primary"
          checked={isItemSelected}
          inputProps={{
            "aria-labelledby": labelId,
          }}
        />
      </TableCell>
      <TableCell
        // component="th"
        id={labelId}
        // scope="row"
        padding="none"
        align="left"
        onClick={handleNavigateToDetails}
        style={{
          ...tableTitleFieldStyles,
          width: columnWidths?.firstName || 170,
          minWidth: columnWidths?.firstName || 170,
          maxWidth: columnWidths?.firstName || 170,
        }}
      >
        {row?.firstName}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.lastName || 170,
          minWidth: columnWidths?.lastName || 170,
          maxWidth: columnWidths?.lastName || 170,
        }}
      >
        {row?.lastName}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.userName || 170,
          minWidth: columnWidths?.userName || 170,
          maxWidth: columnWidths?.userName || 170,
        }}
      >
        {row?.userName}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.id || 190,
          minWidth: columnWidths?.id || 190,
          maxWidth: columnWidths?.id || 190,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',

        }}
        title={row?.id}
      >
        {row?.id}
      </TableCell>

      <TableCell
        padding="none"
        align="left"
        style={{
          ...tableCellStyles,
          textTransform: "capitalize",
          width: columnWidths?.type || 120,
          minWidth: columnWidths?.type || 120,
          maxWidth: columnWidths?.type || 120,
        }}
      >
        {toTitleCase(row?.type ?? "user")}
      </TableCell>

      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.createdAt || 170,
          minWidth: columnWidths?.createdAt || 170,
          maxWidth: columnWidths?.createdAt || 170,
        }}
      >
        {row.createdAt &&
          moment.unix(row.createdAt?.seconds).format("MM-DD-YYYY HH:mm:ss")}
      </TableCell>
      <TableCell
        align="left"
        padding="none"
        style={{
          ...tableCellStyles,
          textTransform: "capitalize",
          width: columnWidths?.isActive || 170,
          minWidth: columnWidths?.isActive || 170,
          maxWidth: columnWidths?.isActive || 170,
        }}
      >
        {row?.isActive === true ? "Active" : "Inactive"}
        {/* {row.status} */}
      </TableCell>
      <TableCell
        align="left"
        padding="none"
        style={{
          ...tableCellStyles,
          textTransform: "capitalize",
          width: columnWidths?.reportedStatus || 155,
          minWidth: columnWidths?.reportedStatus || 155,
          maxWidth: columnWidths?.reportedStatus || 155,
        }}
      >
        {row?.reportedStatus}
      </TableCell>
    </TableRow>
  );
};

export default GAUsersTableRow;

const tableTitleFieldStyles = {
  border: "1px solid #BABABA",
  color: "#00A7CD",
  // fontWeight: 600,
  fontFamily: "Avenir Book, sans-serif",
  paddingLeft: 10,
  height: 30,
};

const tableCellStyles = {
  border: "1px solid #BABABA",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
  paddingLeft: 10,
  height: 30,
};
// const tableStatusCellStyles = {
//   border: "1px solid #BABABA",
//   cursor: "pointer",
//   fontWeight: 600,
// };
